import { useQuickPayViewDrawer } from "@/hooks/invoice/use-quickpay-view-drawer";
import QuickPayViewDrawer from "./quickpay-view-drawer";

export default function QuickPayViewDrawerWrapper() {
  const {
    drawerData: invoice,
    open,
    handleClose,
    isLoading,
    isError,
  } = useQuickPayViewDrawer();

  return (
    <QuickPayViewDrawer
      invoice={invoice}
      open={open}
      handleClose={handleClose}
      isLoading={isLoading}
      isError={isError}
    />
  );
}
